export default __webpack_public_path__ + "static/media/squirrel@2x.6bcddb00.png";